import { memo, useCallback, useState } from 'react';
import { Button, Input } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';
import { AlertCircle, X } from 'lucide-react';

/**
 * One invalid entry: an editable field to correct it and add it, or remove it.
 *
 * @param {object} props
 * @param {string} props.value The invalid text as typed.
 * @param {(value: string, corrected: string) => void} props.onCorrect
 * @param {(value: string) => void} props.onRemove
 */
function InvalidEmailRow({ value, onCorrect, onRemove }) {
  const { t } = useTranslation('people-access');
  const [draft, setDraft] = useState(value);

  const handleChange = useCallback((event) => setDraft(event.target.value), []);
  const handleAdd = useCallback(() => onCorrect(value, draft), [onCorrect, value, draft]);
  const handleRemove = useCallback(() => onRemove(value), [onRemove, value]);

  return (
    <div className="flex items-center gap-2">
      <div className="flex-1">
        <Input
          aria-label={t('invite.people.invalidField', { value })}
          error=" "
          value={draft}
          onChange={handleChange}
          rightIcon={AlertCircle}
        />
      </div>
      <Button variant="secondary" size="sm" onClick={handleAdd}>
        {t('invite.actions.add')}
      </Button>
      <Button
        variant="ghost"
        size="sm"
        leftIcon={X}
        aria-label={t('invite.people.removeInvalid', { value })}
        onClick={handleRemove}
      />
    </div>
  );
}

export default memo(InvalidEmailRow);
